export default {
  sex: {
    male: 'Nam',
    female: 'Nữ',
    other: 'Khác',
    unknown: 'Không xác định',
  },
}
